const t = (o) => ({
  menuPaper: {
    borderRadius: 4,
    border: `1px solid ${o.palette.common.grey20}`,
    boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.05)"
  },
  adornmentText: {
    padding: "15px 0px 15px 15px /* @noflip */",
    cursor: "pointer",
    color: o.palette.common.grey400,
    fontSize: o.typography.fontSize15,
    lineHeight: 1.2,
    fontWeight: o.typography.fontWeightSemiBold
  },
  arrowIcon: {
    display: "inline-block",
    verticalAlign: "middle",
    marginLeft: "0px /* @noflip */",
    maxWidth: 16,
    marginTop: -1,
    lineHeight: 0
  },
  menuList: {
    minWidth: 300,
    height: 350
  },
  menuItem: {
    fontSize: o.typography.fontSize15,
    fontWeight: o.typography.fontWeightSemiBold,
    color: o.palette.common.grey400,
    padding: 16,
    borderBottom: `1px solid ${o.palette.common.grey20}`
  }
}), i = t;
export {
  i as default
};
